var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "5px",
    viewBox: "0 0 8 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Input-Types/Medium/Filter/Default",
    transform: "translate(-74.000000, -18.000000)",
    fill: "#899CB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5940275,18.1800739 C77.8202314,17.9399754 78.1797229,17.9399754 78.4059268,18.1800739 L81.8364875,21.935852 C81.9966488,22.1146898 82.0440224,22.3808311 81.9569185,22.6124232 C81.8698145,22.8440152 81.6650024,22.9964712 81.4362554,23.0000107 L74.5751341,23.0000107 C74.3443096,23.0014736 74.1353104,22.8508592 74.0452888,22.6181583 C73.9552672,22.3854575 74.0018829,22.1163195 74.1634668,21.935852 L77.5940275,18.1800739 Z",
    id: "Icon",
    transform: "translate(78.000000, 20.500005) rotate(-180.000000) translate(-78.000000, -20.500005) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrow);
export default __webpack_public_path__ + "static/media/filter-arrow.db6ca30244b24328e3c9f76b781796bc.svg";
export { ForwardRef as ReactComponent };